import { avatarColor, avatarInitial } from 'lib/avatar';

interface HeaderPlayerNameProps {
  username: string;
  /** Hide text label on narrow viewports */
  compact?: boolean;
  /** Always show username (e.g. mobile portrait header row) */
  forceShowName?: boolean;
  className?: string;
}

export default function HeaderPlayerName({
  username,
  compact = false,
  forceShowName = false,
  className = '',
}: HeaderPlayerNameProps) {
  return (
    <div
      className={`tp-header-player-inner flex min-w-0 max-w-full items-center gap-1.5 ${className}`}
      title={username}
      aria-label={`Logged in as ${username}`}
    >
      <div
        className="tp-header-player-avatar flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-bold leading-none text-white shadow-md ring-1 ring-white/20 sm:h-7 sm:w-7 sm:text-[11px] lg:h-8 lg:w-8 lg:text-xs"
        style={{ background: avatarColor(username) }}
        aria-hidden
      >
        {avatarInitial(username)}
      </div>
      <span
        className={`tp-header-player-name min-w-0 truncate font-medium text-white/90 ${
          forceShowName
            ? 'inline max-w-[8rem] text-[11px] sm:max-w-[10rem]'
            : compact
              ? 'hidden max-w-[4.5rem] text-[10px] min-[640px]:inline sm:max-w-[5.5rem] lg:max-w-[9rem] lg:text-xs'
              : 'max-w-[5rem] text-[10px] sm:max-w-[7rem] sm:text-[11px] lg:max-w-[10rem] lg:text-xs'
        }`}
      >
        {username}
      </span>
    </div>
  );
}
